import {Component, Input} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {
    FaqItemComponent
} from "@white-label/components/page-builder/components/faq/dropdown/faq-item/faq-item.component";
import {FaqModel} from "@white-label/components/page-builder/models/faq.model";


@Component({
  selector: 'white-label-dropdown-faq',
  standalone: true,
    imports: [
        RouterOutlet,
        RouterLink,
        NgOptimizedImage,
        NgClass,
        TranslateModule,
        FaqItemComponent
    ],
  templateUrl: './dropdown-faq.component.html'
})
export class DropdownFaqComponent {
    @Input() componentModel: FaqModel = new FaqModel();

    openItem(question: any){
        this.componentModel.questions.value.map(item => {
            if(item.question.value === question?.question.value){
                return item.opened = true;
            }
            return item.opened = false;
        })
    }
}
